import { User } from '../../../../../shared/models/api/User/User';
import { ConsMgmntWebApiWriteExtRequestApi } from '../../../../../shared/models/generated/ConsentManagementConsMgmntWebApiWriteExtRequestApi';
import { ConsMgmnttWebApiWriteChannelApi } from '../../../../../shared/models/generated/ConsentManagementConsMgmnttWebApiWriteChannelApi';
import { AdvertisingConsentModel } from '../../../../../shared/models/view/AdvertisingConsent';
import { AppFormModel } from './AppFormModel';

export class ModelAdapter {
	public static getConsMgmntWebApirWriteExtReqModel(user: User, appFormModel: AppFormModel, advertisingConsentModel: AdvertisingConsentModel, options: AdvertisngConsentAppDefinition): ConsMgmntWebApiWriteExtRequestApi {
		const model = new ConsMgmntWebApiWriteExtRequestApi({
			IpAddress: appFormModel.Ip,
			ProcessId: appFormModel.ProcessId,
			Herkunftskennzeichen: advertisingConsentModel.HerkunftsKz,
			MailTitel: options.emailtitle,
			Betreff: options.emailsubject,
			Version: options.advertisingconsentversion
		});

		if (user && user.Valid) {
			model.Mitgliedsnummer = user.MglNo;
			model.Vorname = user.UserData.Vorname;
			model.Nachname = user.UserData.Nachname;
			model.StrasseHausnummer = user.UserData.Anschrift.StrasseHausnummer;
			model.Postleitzahl = user.UserData.Anschrift.Postleitzahl;
			model.Ort = user.UserData.Anschrift.Ort;
		}
		else {
			model.Mitgliedsnummer = appFormModel.PersonalData.Mitgliedsnummer;
			model.Vorname = appFormModel.PersonalData.Vorname;
			model.Nachname = appFormModel.PersonalData.Nachname;
			model.StrasseHausnummer = appFormModel.PersonalData.Adresse.StrasseHausnummer;
			model.Postleitzahl = appFormModel.PersonalData.Adresse.Postleitzahl;
			model.Ort = appFormModel.PersonalData.Adresse.Ort;
		}

		if (advertisingConsentModel.Email === 1) {
			model.ChannelEmail = new ConsMgmnttWebApiWriteChannelApi({
				Channel: appFormModel.PersonalData.Email,
				Authorized: true
			});

			model.MailTextEmail = options.emailtextemailconsent;
		}

		if (advertisingConsentModel.Telefon === 1) {
			model.ChannelTel1 = new ConsMgmnttWebApiWriteChannelApi({
				Channel: appFormModel.PersonalData.TelefonNummer,
				Authorized: true
			});

			model.MailTextTelefon = options.emailtexttelephoneconsent;
		}

		if (advertisingConsentModel.Telefon2 === 1) {
			model.ChannelTel2 = new ConsMgmnttWebApiWriteChannelApi({
				Channel: appFormModel.PersonalData.TelefonGeschaeftlichNummer,
				Authorized: true
			});

			model.MailTextTelefon = options.emailtexttelephoneconsent;
		}

		if (advertisingConsentModel.Personalisierung) {
			model.TrackingAuthorized = true;
			model.TrackingReferenzId = advertisingConsentModel.TrackingReferenceId;
			model.TrackingVersion = advertisingConsentModel.TrackingConsentVersion;
		}

		if (advertisingConsentModel.CompanyIdentifier) {
			model.Gesellschaftsname = advertisingConsentModel.CompanyIdentifier;
		}
		if (advertisingConsentModel.CompanyIdentifierReferenceCode) {
			model.GesellschaftsId = advertisingConsentModel.CompanyIdentifierReferenceCode;
		}

		return model;
	}
}